import { useMemo } from 'react';
import { useGoalsContext } from '../contexts/GoalsContext';
import { GoalsCreatorOrModifierUser } from '../lib/hooks/useQueryGoalsCreatorsAndModifiers';

export const useGoalAuditUsers = () => {
  const {
    creatorAndModifiers: { goalsCreators, goalsModifiers },
  } = useGoalsContext();

  const userInfoLookup = useMemo(() => {
    const userInfo = goalsCreators.concat(goalsModifiers);

    return userInfo.reduce(
      (
        userMapping: { [key: string]: GoalsCreatorOrModifierUser },
        user: GoalsCreatorOrModifierUser,
      ) => ({
        ...userMapping,
        [user.id]: user,
      }),
      {},
    );
  }, [goalsCreators, goalsModifiers]);

  return {
    goalsCreators,
    goalsModifiers,
    userInfoLookup,
  };
};
